import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useLayoutContext } from '../../../components/layout/Layout';
import { getMakecodeArcadePageRootStyle } from '../makecodeArcadePageStyles';
import Button from '../../../components/ui/Button';
import Card from '../../../components/ui/Card';
import LeftArrowIcon from '../../../components/icons/LeftArrowIcon';

const TextSpriteExtension: React.FC = () => {
  const navigate = useNavigate();
  const { isMobile } = useLayoutContext();
  const blocks = [
    { title: '타일맵 설정', description: '게임의 배경을 설정하는 블록입니다.', examples: ['set tilemap to [ ]', 'set tilemap to [ ] with [ ]', 'set tilemap to [ ] with [ ] and [ ]'] },
    { title: '타일 배치', description: '특정 위치에 타일을 배치하는 블록입니다.', examples: ['place [ ] at x [ ] y [ ]', 'place [ ] at [ ]'] },
    { title: '타일 확인', description: '특정 위치의 타일을 확인하는 블록입니다.', examples: ['is [ ] at x [ ] y [ ]', 'is [ ] at [ ]'] },
    { title: '타일 변경', description: '특정 위치의 타일을 변경하는 블록입니다.', examples: ['set [ ] at x [ ] y [ ] to [ ]', 'set [ ] at [ ] to [ ]'] }
  ];

  return (
    <div style={getMakecodeArcadePageRootStyle(isMobile)}>
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '24px' }}>
        <Button variant="line" leftIcon={<LeftArrowIcon width={20} height={20} />} onClick={() => navigate('/makecodearcade/extensions')} style={{ marginRight: '16px' }}>돌아가기</Button>
        <h1 style={{ margin: 0, fontSize: '24px', fontFamily: 'var(--font-family-primary)' }}>Text Sprite 알아보기</h1>
      </div>
      <p style={{ margin: '0 0 24px', fontSize: '14px', color: 'var(--Color-text-normal)' }}>Text Sprite는 화면에 텍스트를 바로 표시할 수 있는 확장 블록입니다. 보통은 텍스트를 표시하기 위해서는 대화상자를 활용합니다.</p>
      <div style={{ marginTop: '32px' }}>
        {blocks.map((block, index) => (
          <React.Fragment key={block.title}>
            <Card padding="24px" style={{ marginBottom: '16px' }}>
              <h2 style={{ margin: '0 0 8px', fontSize: '18px', fontWeight: 600 }}>{block.title}</h2>
              <p style={{ margin: '0 0 16px', fontSize: '14px', color: 'var(--Color-text-normal)' }}>{block.description}</p>
              <div style={{ marginTop: '16px' }}>
                <div style={{ fontSize: '12px', fontWeight: 600, marginBottom: '8px' }}>예시:</div>
                {block.examples.map((example, i) => <div key={i} style={{ padding: '8px', marginBottom: '8px', background: '#f5f5f5', fontFamily: 'monospace', fontSize: '13px', borderRadius: '4px' }}>{example}</div>)}
              </div>
            </Card>
            {index < blocks.length - 1 && <div style={{ height: '1px', background: '#eee', margin: '16px 0' }} />}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default TextSpriteExtension;
